import { render, staticRenderFns } from "./ManageThreats.vue?vue&type=template&id=220a59be&"
import script from "./ManageThreats.vue?vue&type=script&lang=js&"
export * from "./ManageThreats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports